const StarRating = ({
  rating,
  className = 'h-[1.6rem] w-[1.6rem]',
}: {
  rating: number;
  className?: string;
}) => {
  return (
    <div className="flex items-center gap-x-1">
      {Array.from({ length: 5 }, (_, index) => {
        const isActive = index < Math.round(rating);
        return (
          <StarIcon key={index} isActive={isActive} className={className} />
        );
      })}
    </div>
  );
};

const StarIcon = ({
  className,
  isActive = true,
}: {
  className?: string;
  isActive?: boolean;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.0013 14.8083L15.1513 17.9166L13.7846 12.0583L18.3346 8.11665L12.343 7.60831L10.0013 2.08331L7.65964 7.60831L1.66797 8.11665L6.21797 12.0583L4.8513 17.9166L10.0013 14.8083Z"
      fill={isActive ? '#C41719' : '#D4D4D8'}
    />
  </svg>
);

export default StarRating;
